import DashboardLayout from '@/views/Layout/DashboardLayout.vue';

import dashboard from './modules/dashboard';
import authPages from './modules/authPages';
import assistAdminPages from './modules/assist-admin';

const routes = [
    {
        path: '/',
        redirect: '/applications',
        name: 'Home',
        component: DashboardLayout,
        meta: {requiresAuth: true},
        children: [
            ...dashboard,
        ],
    },
    assistAdminPages,
    authPages,
];

export default routes;
